export function truevalueedit(truevalue, title, field) {
  if (truevalue[0] === true) {
    // console.log(field, 'field', truevalue[1], 'truevalue[1]', title, 'title')
    title[field] = truevalue[1]
    // console.log(title, 'TITLE')
    return title
  }

  // console.log(title, 'TITLE')
  return title
}
